import {Box, Cards, Link} from '@amzn/awsui-components-react';
import * as React from 'react';
import {RouteComponentProps} from 'react-router-dom';
import {
    getAcPageUrl,
    getDynamicExecutionPageUrl,
    getExclusionGroupPageUrl,
    getIapPageUrl,
    getIogPageUrl,
    getRuleGroupPageUrl,
    getStartWorkflowPageUrl,
    getWorkflowHistoryPageUrl,
} from '../backend/internalUrls';
import '../css/welcomeBox.css';
import {isExternalLink} from './navigation/menu';

interface Card {
    name: string;
    description: string;
    link: string;
}

type WelcomePageProps = RouteComponentProps

const WelcomePage: React.FC<WelcomePageProps> = () => {

    const cardDefinition = {
        header: (card: Card) => {
            if (isExternalLink(card.link)) {
                return <Link external fontSize='heading-l' href={card.link} >{card.name}</Link>
            } else return <Link fontSize='heading-l' href={card.link}>{card.name}</Link>
        },
        sections: [
            {
                content: (card: Card) => card.description,
            },
        ],
    }

    const cardsPerRow = [
        {minWidth: 500, cards: 2},
    ]

    const searchCards = [
        {
            name: 'AC',
            description: 'Availability Consumer',
            link: getAcPageUrl(),
        },
        {
            name: 'IAP',
            description: 'Inventory Availability Pool',
            link: getIapPageUrl(),
        },
        {
            name: 'IOG',
            description: 'Inventory Owner Group',
            link: getIogPageUrl(),
        },
        {
            name: 'IOGL',
            description: 'Inventory Owner Group Location',
            link: getIogPageUrl(),
        },
    ]

    const workflowCards = [
        {
            name: 'Start',
            description: 'Start a mapping workflow',
            link: getStartWorkflowPageUrl(),
        },
        {
            name: 'History',
            description: 'See all workflow history',
            link: getWorkflowHistoryPageUrl(),
        },
    ]

    const dncCards = [
        {
            name: 'History',
            description: 'See all dynamic executions',
            link: getDynamicExecutionPageUrl(),
        },
        {
            name: 'Rule Groups',
            description: 'DNC Rule Groups',
            link: getRuleGroupPageUrl(),
        },
        {
            name: 'Exclusion Groups',
            description: 'DNC Exclusion Groups',
            link: getExclusionGroupPageUrl(),
        },
    ]

    const contactCards = [
        {
            name: 'Feature',
            description: 'Request a feature',
            link: 'https://issues.amazon.com/issues/create?assignedFolder=85c052fc-ea24-48c4-8b44-f68a005da82e',
        },
        {
            name: 'Wiki',
            description: 'SCOT FO Inventory Mapping',
            link: 'https://w.amazon.com/bin/view/InventoryMapping',
        },
    ]

    return (
        <div>
            <Box className='welcome-box'><h1>Welcome</h1></Box>
            <br/>
            <div>
                <Box variant='h2'>Search</Box>
                <br/>
                <Cards
                    cardDefinition={cardDefinition}
                    cardsPerRow={cardsPerRow}
                    items={searchCards}
                />
            </div>
            <div>
                <Box variant='h2'>Mapping workflow</Box>
                <br/>
                <Cards
                    cardDefinition={cardDefinition}
                    cardsPerRow={cardsPerRow}
                    items={workflowCards}
                />
            </div>
            <div>
                <Box variant='h2'>Dynamic Execution</Box>
                <br/>
                <Cards
                    cardDefinition={cardDefinition}
                    cardsPerRow={cardsPerRow}
                    items={dncCards}
                />
            </div>
            <div>
                <Box variant='h2'>Contact us</Box>
                <br/>
                <Cards
                    cardDefinition={cardDefinition}
                    cardsPerRow={cardsPerRow}
                    items={contactCards}
                />
            </div>
        </div>
    )
}

export default WelcomePage
